import '../webpackPublicPath';
import { startup } from '../startup';
import { atomIframe } from './atomIframe';

startup('atomIframe', null, atomIframe);
